/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../.kubb/ToZod.ts";
import type { ECourseHistoryType } from "../types/ECourseHistoryType.ts";

/**
 * @description 1 = ByDiscipline | 2 = ByClassGroup |
 */
export const eCourseHistoryTypeSchema = z
  .union([z.literal(1), z.literal(2)])
  .describe(
    "1 = ByDiscipline | 2 = ByClassGroup | ",
  ) as unknown as ToZod<ECourseHistoryType>;
